module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fff",
      "padding": "20px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listData.list,
      "applylist": "",
      "height": _vm.tableHeight,
      "row-key": "id"
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "252px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单信息",
      "fixed": "left",
      "prop": "title",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.items), function(goods, i) {
          return _c('div', [_vm._v("\n                    " + _vm._s(goods.title) + "\n                "), _c('p', [_vm._v("\n                  规格: " + _vm._s(goods.sku.sku_formart) + "*" + _vm._s(goods.count) + "\n                ")])])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "prop": "cate_list"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.pay_price) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(scope.row.status_buttons.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "leixing"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'OrderDetail',
              query: {
                id: scope.row.id
              }
            }),
            expression: "{name:'OrderDetail',query:{id:scope.row.id}}"
          }]
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "plain": ""
          }
        }, [_vm._v("查看详情")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rb-table-pager"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.params.size,
      "current-page": parseInt(_vm.listData.currentpage),
      "layout": "total,sizes,prev, pager, next, jumper",
      "total": parseInt(_vm.listData.total)
    },
    on: {
      "size-change": _vm.sizeChange,
      "current-change": _vm.currentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2f66ec2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/order/orderList.vue
// module id = 1315
// module chunks = 0